import React from "react";
import icon from "assets/icons/search.svg";
import "./SearchInput.scss";

interface Props {
  placeholder?: string;
  value: string;
  onChange: (e: string) => void;
  disabled?: boolean;
  isSmall?: boolean;
  showIcon?: boolean;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
}

const SearchInput: React.FC<Props> = ({
  placeholder,
  value,
  onChange,
  disabled,
  isSmall,
  showIcon = true,
  onKeyDown,
}) => {
  return (
    <div
      className={`
        search-input
        ${isSmall ? "search-input--small" : ""}
        ${disabled ? "search-input--disabled" : ""}
      `}
    >
      {showIcon && <img src={icon} alt="" className="search-input__icon" />}

      <input
        type="text"
        className="search-input__field"
        value={value}
        disabled={disabled}
        placeholder={placeholder ?? ""}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
      />
    </div>
  );
};

export default SearchInput;
